import { render, staticRenderFns } from "./travels-home-dashboard.vue?vue&type=template&id=d37b04a2&scoped=true"
import script from "./travels-home-dashboard.vue?vue&type=script&lang=js"
export * from "./travels-home-dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37b04a2",
  null
  
)

export default component.exports